import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { handlePointerDown} from '../../lib/modal-helper';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import constants from '../../constants';

const TrialActivationModal = () => {
    const strings = useSelector(selectAllStrings);
    const history = useHistory();
    
    return (<div className="modal" id="trial_activation_modal">
        <div className="modal-body" id="trial_activation_modal_body">
            <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'trial_activation_modal_body')}>
                <div className="move-handler"></div>
            </div>
            <div className="modal-content">
                <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'trial_activation_modal_body')}>
    
                    <span onPointerDown={event => event.preventDefault()}>{strings.free_trial}</span>
                    <hr/>
                </div>
                <div className="icon">
                    <FontAwesomeIcon icon={faCheckCircle}/>
                </div>
                <div className="modal-title">{strings.thank_you}</div>
                <div className="modal-text">{strings.you_have_activated}</div>
                <div className="modal-text support">{strings.for_question+' '+(constants.environment == 'iOS' ? '' : strings.write_to_info)}
                </div>
                <button className="btn" id="continue_button" onClick={event => {
                event.preventDefault();
                history.push('/home');
            }}>{strings.go_to_home}</button>
    
            </div>
        </div>
    </div>);
};

export default TrialActivationModal;